<template>
	<div id="StepWizardSloganHome" class="text-left">
		<div class="title-area">
			<h4>{{ stepName }}</h4>
		</div>
		<div class="input-area">
			<div class="row">
				<div
					class="col-12 col-md-4 mb-5"
					v-for="(slogan, index) in slogans"
					:key="index"
					@click="updateSelectedSlogan(slogan)"
				>
					<CardStepWizardSloganHome
						:coverImage="normalizeUrl(coverImage)"
						:selected="checkSelectedSlogan(slogan.id)"
						:slogan="slogan"
					>
						<textarea
							@click="checkAndClear"
							class="textarea-slogan"
							cols="20"
							rows="2"
							maxlength="250"
							v-model="slogan.text"
							v-if="slogan.id == 1"
						></textarea>
						<p v-else>{{ slogan.text }}</p>
					</CardStepWizardSloganHome>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				coverImage: "",
				dirty: false,
				selectedSlogan: {
					id: null,
					text: "",
				},
				slogans: [],
			};
		},
		props: {
			stepName: {
				type: String,
				required: false,
			},
			orientation: {
				type: String,
				required: false,
			},
			
		},
		components: {
			CardStepWizardSloganHome: () =>
				import("@/components/molecules/CardStepWizardSloganHome"),
		},
		created() {
			this.$store.dispatch("WIZARD_SHOW_SKIP", [true]);
			this.slogans = [...this.$store.state.wizard.segmentSlogans];
			if(this.$store.state.wizard.dataSite.highlights.length > 0){
				this.coverImage = this.$store.state.wizard.dataSite.highlights[0].mainImage;
			}
		},
		mounted() {
			this.$emit("updateStep");
			this.checkStep();
		},
		watch: {
			selectedSlogan() {
				if (this.selectedSlogan.id != null) {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
				}
			},
		},
		methods: {
			checkAndClear() {
				if (!this.dirty) {
					this.dirty = true;
					this.slogans[0].text = "";
				}
			},
			updateSelectedSlogan(slogan) {
				this.selectedSlogan = slogan;
			},
			updateSloganText(slogan) {
				let customSlogam = this.slogans.findIndex(
					(slogan) => slogan.id == 1
				);
				this.selectedSlogan = slogan;
				this.slogans[customSlogam] = slogan;
			},
			checkSelectedSlogan(id) {
				return id === this.selectedSlogan.id;
			},
			checkStep() {
				let hasPost = this.$store.state.wizard.dataSite.highlights.some(
					(item) => item.title
				);
				if (hasPost) {
					if(this.orientation == 'foward'){
						this.$emit("nextStep");
					}else{
						this.$emit("trigger-back-step");
					}
				} else {
					if (this.$store.state.wizard.dataSite.slogan) {
						this.selectedSlogan = {
							...this.$store.state.wizard.dataSite.slogan,
						};
					}
				}
			},
			normalizeUrl(item) {
				if (item.startsWith(process.env.CDN_URL)) {
					return item;
				}
				return `${process.env.CDN_URL}${item}`;
			},
		},
		destroyed() {
			if (this.selectedSlogan.id !== null) {
				this.$store.dispatch("WIZARD_UPDATE_SLOGAN_HOME", [
					this.selectedSlogan,
				]);
			}
			this.$store.dispatch("WIZARD_BOTTOM_BUTTONS", [true]);
		},
	};
</script>

<style scoped>
	#app .input-area .textarea-slogan {
		background: transparent;
		text-align: center;
		color: #fff;
		z-index: 3;
		position: relative;
		border-bottom: none !important;
		-webkit-appearance: textfield;
		overflow-x: hidden;
	}
	#app .input-area .textarea-slogan:focus {
		border-bottom: none !important;
	}
	.text-slogan ::-webkit-scrollbar {
		width: 10px;
	}
	.text-slogan ::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px grey; 
		border-radius: 10px;
	}
	.text-slogan ::-webkit-scrollbar-thumb {
		background: #cecece; 
		border-radius: 10px;
	}
	.text-slogan ::-webkit-scrollbar-thumb:hover {
		background: #aaaaaa; 
	}
</style>


// WEBPACK FOOTER //
// src/components/organisms/StepWizardSloganHome.vue